import '../../styles/card.scss';
import CardPanel from './cardpanel';
import Typography from '@components/typography';
import { KeyInformationBanner } from 'interface';

export interface CardAutoProps {
  data: KeyInformationBanner;
  'data-cy': string;
}

export const Card: React.FC<CardAutoProps> = ({ 'data-cy': dataCy, data }) => {
  const getPanels = () =>
    data.items.map((x) => (
      <CardPanel
        key={x.heading}
        title={x.heading}
        icon={x.iconSrc}
        content={x.text}
      />
    ));

  return getPanels().length > 0 ? (
    <div className="card" data-cy={dataCy}>
      <Typography variant="h2" size="x" className="card__title">
        {data.heading}
      </Typography>
      <div className="card__content">{getPanels()}</div>
    </div>
  ) : null;
};

export default Card;
